import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AbstractAlcmeonBackendInterceptor } from './abstract-alcmeon-backend-interceptor';
import { AlcmeonContextService } from '../alcmeon-context/alcmeon-context.service';
import { TrackService } from '../track/track.service';

/**
 * Interceptor that sets the 'X-Alcmeon-Session' for calls to alcmeon.com backend
 */
@Injectable()
export class AlcmeonSessionInterceptor extends AbstractAlcmeonBackendInterceptor {
  constructor(private alcmeonContext: AlcmeonContextService, private trackService: TrackService) {
    super();
  }

  protected doIntercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headerValue = JSON.stringify({
      user_id: this.alcmeonContext.self ? this.alcmeonContext.self.id : 0,
      session_id: this.alcmeonContext.self ? this.alcmeonContext.self.session_id : 0,
      client_session_id: this.trackService.sessionId,
      company_id: this.alcmeonContext.companyId || 0,
    });
    const config = {
      headers: request.headers.set('X-Alcmeon-Session', headerValue),
    };
    return next.handle(request.clone(config));
  }
}
